module.exports = __webpack_public_path__ + "static/media/victory.97fabd28.png";